// PWA Service Worker Registration
// This file handles service worker registration and updates

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      registerValidSW(swUrl);
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[PWA] Service Worker registered successfully:', registration.scope);

      // Check for updates more frequently (every 5 minutes)
      setInterval(() => {
        console.log('[PWA] Checking for updates...');
        registration.update();
      }, 5 * 60 * 1000);

      // Also check for updates when page becomes visible
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          console.log('[PWA] Page visible, checking for updates...');
          registration.update();
        }
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New update available - FORCE UPDATE
              console.log('[PWA] New version detected! Updating...');

              // Automatically skip waiting and reload
              installingWorker.postMessage({ type: 'SKIP_WAITING' });
              
              // Show brief notification before reload
              const updateMsg = document.createElement('div');
              updateMsg.innerHTML = `
                <div style="position: fixed; top: 20px; left: 50%; transform: translateX(-50%); 
                            background: #4A90E2; color: white; padding: 16px 24px; 
                            border-radius: 8px; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                            font-family: system-ui, -apple-system, sans-serif; font-size: 14px;">
                  🔄 New version available! Updating...
                </div>
              `;
              document.body.appendChild(updateMsg);
              
              // Reload after 1 second
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              // Content cached for offline use
              console.log('[PWA] Content is cached for offline use.');
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Service Worker registration failed:', error);
    });

  // Reload page when new service worker takes control
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.log('[PWA] Controller changed, reloading...');
    window.location.reload();
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        // Clear all caches
        return caches.keys().then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cacheName) => {
              console.log('[PWA] Deleting cache:', cacheName);
              return caches.delete(cacheName);
            })
          );
        });
      })
      .then(() => {
        console.log('[PWA] Service Worker unregistered and caches cleared');
        // Reload to ensure clean state
        window.location.reload();
      })
      .catch((error) => {
        console.error('[PWA] Service Worker unregistration failed:', error);
      });
  }
}

// Force clear all caches
export function clearAllCaches() {
  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      return Promise.all(
        cacheNames.map((cacheName) => {
          console.log('[PWA] Force clearing cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('[PWA] All caches cleared!');
      window.location.reload();
    });
  }
}

// Check if app is running as PWA
export function isPWA() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
}

// Check if browser supports PWA installation
export function canInstallPWA() {
  return 'serviceWorker' in navigator && 
         'PushManager' in window &&
         !isPWA();
}
